import React from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

import {
  FacilitatorChat,
  FasilitatorChatProps
} from '../../../components/facilitator/chat';
import {
  FacilitatorChatContext,
  FacilitatorChatContextProps
} from '../../../contexts/facilitator-chat';
import { GetGroupChatHistory } from '../../../services/groups';
import { ChatState } from '../../../types/state/websocket/chat-state';

export const FacilitatorGroupChat = ({
  onSendMessage = () => {},
  ...props
}: FasilitatorChatProps) => {
  const { gameCode } = useParams();
  const auth = useAuth();

  const { chatHub } = React.useContext(
    FacilitatorChatContext
  ) as FacilitatorChatContextProps;

  const [messages, setMessages] = React.useState<ChatState[]>([]);

  const groupCode = props.item?.id ?? '';

  const getChatHistoryAsync = () => {
    let newChat: ChatState[] = [];
    GetGroupChatHistory(groupCode, gameCode!).then((response) => {
      response?.data.forEach((chat) => {
        newChat.push({
          author: {
            id:
              chat.playerCode === '00000000-0000-0000-0000-000000000000'
                ? auth?.user?.profile.sub!
                : chat.playerCode,
            name: chat.playerName,
            avatarUrl: chat.playerAvatar
          },
          timestamp: new Date(chat.sentDateUtc),
          group: 'group-chat',
          text: chat.message
        });
      });
      setMessages(newChat);
    });
  };

  React.useEffect(() => {
    if (!chatHub || !groupCode) return;

    chatHub.on('GroupChatReceived', (data) => {
      const { senderCode, senderName, senderAvatar, message, sentDateUtc } =
        data;
      const chat = {
        author: {
          id:
            senderCode === '00000000-0000-0000-0000-000000000000'
              ? auth?.user?.profile.sub!
              : senderCode,
          name: senderName,
          avatarUrl: senderAvatar,
          groupId: groupCode
        },
        timestamp: new Date(sentDateUtc),
        group: 'group-chat',
        text: message
      };
      setMessages((prev) => [...prev, chat]);
    });
  }, [chatHub, groupCode]);

  React.useEffect(() => {
    getChatHistoryAsync();
  }, [props.item]);

  return (
    <FacilitatorChat
      item={props.item}
      messages={messages}
      onSendMessage={onSendMessage}
    />
  );
};
